import Vue from 'vue';
import SwiperClass, {Autoplay} from 'swiper';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
SwiperClass.use([Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
